import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { NavigationService } from '../../../../../../shared/services/navigation/navigation.service';
import { FormularzUszkodzenService } from '../../../../../../shared/components/proces-uszkodzen/zgloszenie/ubezpieczenie/podsumowanie/lista-przedmiotow/rodzaj-elementu/uszkodzenia/formularz-uszkodzen.service';
import { UuidGeneratorService } from '../../../../../../shared/services/id-generator/uuid-generator.service';
import { Subscription } from 'rxjs';
import { FormControl, FormGroup } from '@angular/forms';
import {Directive, OnDestroy, OnInit} from '@angular/core';
import { selectZbiorUszkodzenById } from '../../../../../../shared/store/zbior-uszkodzen/zbiorUszkodzen.selectors';

@Directive()
export abstract class UszkodzenieZKomentarzemBaseComponent implements OnInit, OnDestroy {
  protected routeSubscription!: Subscription;
  protected zbiorUszkodzenSubscription!: Subscription;
  protected idPrzedmiotuUbezpieczenia!: number;
  protected idZbioruUszkodzen!: string;
  formularzUszkodzenia!: FormGroup;

  constructor(
    protected route: ActivatedRoute,
    protected store: Store,
    protected navigation: NavigationService,
    protected formularzUszkodzenService: FormularzUszkodzenService,
    protected idGenerator: UuidGeneratorService
  ) {}

  ngOnInit(): void {
    this.routeSubscription = this.route.queryParams.subscribe(params => {
      this.idPrzedmiotuUbezpieczenia = +params.idPrzedmiotu;
      this.idZbioruUszkodzen = params.idZbioruUszkodzen;
    });
    this.formularzUszkodzenia = new FormGroup({
      komentarz: new FormControl(null)
    });
    this.inicjujIstniejacyKomentarzDoEdycji();
  }

  protected inicjujIstniejacyKomentarzDoEdycji(): void {
    if (this.idZbioruUszkodzen) {
      this.zbiorUszkodzenSubscription = this.store.select(selectZbiorUszkodzenById, this.idZbioruUszkodzen).subscribe(
        (zbiorUszkodzen) => {
          if (zbiorUszkodzen) {
            this.formularzUszkodzenia.controls.komentarz.setValue(zbiorUszkodzen.uszkodzenia[0].parametry.komentarz);
          }
        }
      );
    }
  }

  wroc(): void {
    this.navigation.back();
  }

  nextEnabled(): boolean {
    return !!this.formularzUszkodzenia.controls.komentarz.value?.trim();
  }

  ngOnDestroy(): void {
    this.routeSubscription.unsubscribe();
    if (this.zbiorUszkodzenSubscription) {
      this.zbiorUszkodzenSubscription.unsubscribe();
    }
  }
}
